import type { ReactNode } from 'react';
import { css, type Theme } from '@emotion/react';
import { Typography } from 'client/components/Typography';

export const SectionTitle = ({ type, children }: { type: 'web' | 'dev'; children: ReactNode }) => (
  <Typography variant="h6" component="div" css={[titleStyle, type === 'dev' && devStyle]}>
    {children}
  </Typography>
);

const titleStyle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: -8px;

  > svg {
    color: ${theme.color.primary[100]};
    transform: translateY(-2px);
  }
`;

const devStyle = (theme: Theme) => css`
  > svg {
    color: ${theme.color.secondary[100]};
  }
`;
